// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZPUF","label":"styles_label__Zh1nw"};